import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../index';

export interface MigrationToSNModalState {
  shouldShowMigrationToSNModal: boolean;
}

const initialState = {
  shouldShowMigrationToSNModal: false,
} as MigrationToSNModalState;

export const migrationToSNModalSlice = createSlice({
  name: 'migrationToSNModal',
  initialState,
  reducers: {
    setShouldShowMigrationToSNModal: (
      state,
      { payload }: PayloadAction<boolean>,
    ) => {
      state.shouldShowMigrationToSNModal = payload;
    },
  },
});

export const migrationToSNModalState = (state: RootState) =>
  state.migrationToSNModal as MigrationToSNModalState;

export const { setShouldShowMigrationToSNModal } =
  migrationToSNModalSlice.actions;

export default migrationToSNModalSlice.reducer;
